import { render, staticRenderFns } from "./ShipVettingDisclaimer.vue?vue&type=template&id=4dd579a0&scoped=true&"
import script from "./ShipVettingDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ShipVettingDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ShipVettingDisclaimer.vue?vue&type=style&index=0&id=4dd579a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd579a0",
  null
  
)

export default component.exports